import { makeStyles, Theme } from '@material-ui/core/styles'
import { IStylesProps } from './Interface'

export default makeStyles<Theme, IStylesProps>(theme => ({
  root: {
    pointerEvents: ({ disabled }) => (disabled ? 'none' : 'initial'),
    width: 40,
    height: 40,
    '&:hover': {
      cursor: 'pointer'
    }
  },
  icon: {
    color: '#fff',
    transform: 'scale(-1.5, 1.5)',
    width: 22,
    height: 22
  },
  helpIcon: {
    color: theme.palette.common.lightOrange,
    marginRight: 16,
    '&:hover': {
      cursor: 'pointer'
    }
  },
  tooltip: {
    backgroundColor: 'rgba(255,255,255,0.8)',
    color: '#000',
    width: 100,
    padding: 15
  }
}))
